// apps/spa/src/components/layout/AppShell.tsx
// Top-level chrome — ambient backdrop + sticky <Header /> + <main><Outlet /></main>.
// No sidebar, no footer.

import { Outlet } from 'react-router';
import { Header } from './Header';
import { AmbientBackground } from '@/components/visual/AmbientBackground';

export function AppShell() {
  return (
    <div className="relative min-h-screen text-foreground font-body">
      <AmbientBackground variant="subtle" />
      <Header />
      <main className="container mx-auto py-6">
        <Outlet />
      </main>
    </div>
  );
}
